var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAlertTriangleOutlined = function SvgAlertTriangleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 12,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4246",
    fillRule: "evenodd",
    d: "M7.816.093A.6.6 0 0 1 8 .28l6.74 10.801c.175.28.092.65-.185.827a.6.6 0 0 1-.316.092H.759a.596.596 0 0 1-.593-.6c0-.112.032-.223.091-.319L6.998.28a.59.59 0 0 1 .818-.187m-.317 8.385a1.173 1.173 0 1 0 .002 2.346A1.173 1.173 0 0 0 7.5 8.478m.19-5.87H7.31a.596.596 0 0 0-.593.598v3.498c0 .331.265.6.593.6h.377a.596.596 0 0 0 .593-.6V3.206c0-.33-.266-.599-.593-.599",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAlertTriangleOutlined);
export default ForwardRef;